export default "__VITE_ASSET__DSSgn5Qi__"